import apiClient from '~/config/apiClient';

import { ChatUserModel, CreateGroupChannelDto, CreateGroupChannelRes } from './types';

export const getUserData = (userId?: string) => {
  return apiClient.get<ChatUserModel>(`/sendbird/user/${userId}`);
};

export const createChannel = (payload: CreateGroupChannelDto) => {
  return apiClient.post<CreateGroupChannelRes>(`/sendbird/group-channel`, payload);
};
